import "./Footer.css";
import { useDispatch, useSelector } from "react-redux";
import { setStep, setError } from "../../redux/reducer";

const Footer = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector((state) => state.step);

  const {
    name = "",
    email = "",
    phone = "",
  } = useSelector((state) => state.PersonalInfo || {});

  const handleNext = () => {
    // clear previous errors
    dispatch(setError({ nameError: "", emailError: "", phoneError: "" }));

    let hasError = false;
    const errors = {};

    if (currentStep === 1) {
      if (!name.trim()) {
        errors.nameError = "This field is required";
        hasError = true;
      }

      if (!email.trim()) {
        errors.emailError = "This field is required";
        hasError = true;
      }

      if (!phone.trim()) {
        errors.phoneError = "This field is required";
        hasError = true;
      }

      if (hasError) {
        dispatch(setError(errors));
        return;
      }
    }

    // ✅ move to next step only if valid
    dispatch(setStep(currentStep + 1));
  };

  const handlePrev = () => {
    if (currentStep > 1) {
      dispatch(setStep(currentStep - 1));
    }
  };

  return (
    <div className="footer">
      <button
        className="prevBtn"
        onClick={handlePrev}
        disabled={currentStep === 1}
      >
        Go Back
      </button>

      <button
        className="nextBtn"
        onClick={handleNext}
        disabled={currentStep === 5}
      >
        Next Page
      </button>
    </div>
  );
};

export default Footer;
